var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGridLayoutLandscape(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 45,
    viewBox: "0 0 62 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 61,
    height: 44,
    rx: 4.5,
    fill: "#EAEAEA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 61,
    height: 44,
    rx: 4.5,
    stroke: "#FAFAFA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 54.5,
    y: 6.5,
    width: 8,
    height: 47,
    rx: 1.5,
    transform: "rotate(90 54.5 6.5)",
    fill: "#D3D3D3",
    stroke: "#FAFAFA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 18.5,
    width: 8,
    height: 13,
    rx: 1.5,
    transform: "rotate(90 20.5 18.5)",
    fill: "#D3D3D3",
    stroke: "#FAFAFA"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 37.5,
    y: 18.5,
    width: 8,
    height: 13,
    rx: 1.5,
    transform: "rotate(90 37.5 18.5)",
    fill: "#D3D3D3",
    stroke: "#FAFAFA"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 54.5,
    y: 18.5,
    width: 8,
    height: 13,
    rx: 1.5,
    transform: "rotate(90 54.5 18.5)",
    fill: "#D3D3D3",
    stroke: "#FAFAFA"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 30.5,
    width: 8,
    height: 21,
    rx: 1.5,
    transform: "rotate(90 29 30.5)",
    fill: "#D3D3D3",
    stroke: "#FAFAFA"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 30.5,
    width: 8,
    height: 21,
    rx: 1.5,
    transform: "rotate(90 54 30.5)",
    fill: "#D3D3D3",
    stroke: "#FAFAFA"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 61,
    height: 44,
    rx: 4.5,
    stroke: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridLayoutLandscape);
export default __webpack_public_path__ + "static/media/GridLayoutLandscape.98ed11b9de78df371073cb4e2ae130f8.svg";
export { ForwardRef as ReactComponent };